// AudioContext.jsx
import React, { createContext, useContext } from 'react';
import useAudioManager from '../customhook/useAudioManager';

type AudioManagerType = {
  musicVolume: number;
  sfxVolume: number;
  isMuted: boolean;
  toggleMute: () => void;
  updateMusicVolume: (volume: any) => void;
  updateSfxVolume: (volume: any) => void;
  playMusic: (src: any, loop?: boolean) => void;
  playSfx: (src: any) => void;
};

const AudioContext = createContext<AudioManagerType | null>(null);

export const AudioProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const audioManager = useAudioManager();

  return (
    <AudioContext.Provider value={audioManager}>
      {children}
    </AudioContext.Provider>
  );
};

export const useAudio = () => {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error('useAudio precisa estar dentro de AudioProvider');
  }
  return context;
};
